export const CookieValue = {
  False: 'false',
  True: 'true',
};
